export enum Role {
    ItineraryViewerAgencyManager,
}

export const permissions = {
    "settings.edit": [Role.ItineraryViewerAgencyManager],
    "settings.read": [Role.ItineraryViewerAgencyManager],
    "capacityPlanning.read": [Role.ItineraryViewerAgencyManager],
    "capacityPlanning.edit": [Role.ItineraryViewerAgencyManager]
};

export type PermissionName = keyof typeof permissions;
